<div *ngIf="!deviceService.isMobile() && isExpanded" [@moveQRCode]="qrCodePosition" class="w-[256px] z-[1000] absolute">
    <img *ngIf="channel && notification.qr_code?.url" [src]="notification.qr_code?.url" [ngStyle]="{ width: window.innerWidth * 0.12 + 'px', height: window.innerWidth * 0.12
                            + 'px' }"/>
    <ngx-qrcode-styling *ngIf="channel && !notification.qr_code?.url" [config]="qrcodeConfig"></ngx-qrcode-styling>
    <div class="w-[256px] h-[256px] text-center" *ngIf="currentAdScreen === 'First'">
        <h1 class="!text-[2vw] my-4 p-2 text-white wide:leading-loose">{{ pageCaptions[0] }}</h1>
    </div>
</div>
<!--DESKTOP VIEW-->
<div *ngIf="!deviceService.isMobile()" class="diagonal-divide" [ngStyle]="{ 'grid-template-columns': getGridTemplateColumns() }">
    <div [@expandCollapse]="isExpanded ? 'expanded' : 'collapsed'" class="h-full polygon-container overflow-visible" [ngStyle]="getBackgroundColorClass()">
        <!--EXPANDED VIEW WHERE THE PURPLE IS MAJORITY OF THE SCREEN - DELETE FADE IN STUFF-->
        <div class="h-full overflow-visible" *ngIf="isExpanded">
            <!-- First Ad Screen -->
            <div class="fade-in flex flex-col items-start justify-between w-full h-full py-[30px] pl-[30px]" *ngIf="currentAdScreen === 'First'">
                <div>
                    <p class="title text-white font-bold text-[2.7vw] w-[55%]">{{ pageTitles[0] }}</p>
                </div>

                <!-- <div class="w-[80%] h-fit items-center text-center mt-[5%] justify-center flex flex-col">
                    <div class="w-[256px] h-[256px] text-center">
                        <h1 class="!text-[2vw] my-4 p-2 text-white wide:leading-loose">{{ pageCaptions[0] }}</h1>
                    </div>
                </div> -->
            </div>
            <!-- Second Ad Screen -->
            <div class="fade-in flex flex-col items-start justify-between w-full h-full py-[30px] pl-[30px]" *ngIf="currentAdScreen === 'Second'">
                <p class="title text-white font-bold text-[2.7vw] w-[45%] wide:leading-loose">
                    {{ pageTitles[1] }}
                </p>
                <div class="w-[75%] h-full items-center justify-center flex flex-col">
                    <div class="w-full flex flex-row justify-evenly overflow-hidden" [@slideImages]="currentAdScreen">
                        <img [@slideLeftImage]="currentAdScreen" src="https://jotto-imgs.s3.us-west-2.amazonaws.com/ad_2_2.png" alt="ad_2_2" class="slide-image"/>
                        <img src="https://jotto-imgs.s3.us-west-2.amazonaws.com/ad_2_1.png" alt="ad_2_1" class="slide-image center-image"/>
                        <img [@slideRightImage]="currentAdScreen" src="https://jotto-imgs.s3.us-west-2.amazonaws.com/ad_2_3.png" alt="ad_2_3" class="slide-image"/>
                    </div>
                    <div class="text-center">
                        <h1 class="!text-[2vw] my-4 text-white">{{ pageCaptions[1] }}</h1>
                    </div>
                </div>
            </div>
            <!-- Third Ad Screen -->
            <div class="fade-in flex flex-col items-start justify-between w-full h-full py-[30px] pl-[30px]" *ngIf="currentAdScreen === 'Third'">
                <p class="title text-white font-bold text-[2.7vw] w-[45%] wide:leading-loose">{{ pageTitles[2] }}</p>
                <div class="w-[75%] h-full items-center justify-center flex flex-col">
                    <div class="report-container">
                        <img src="https://jotto-imgs.s3.us-west-2.amazonaws.com/third_1.png" alt="ad_3_1" class="report-image" [@reportMoveFirst]="animationState"/>
                        <img src="https://jotto-imgs.s3.us-west-2.amazonaws.com/third_2.png" alt="ad_3_2" class="report-image" [@reportMove]="animationState"/>
                    </div>
                    <div class="text-center">
                        <h1 class="!text-[2vw] mt-2 my-4 p-2 text-white">{{ pageCaptions[2] }}</h1>
                    </div>
                </div>
            </div>
            <!-- Fourth Ad Screen` -->
            <div class="fade-in flex flex-col items-start justify-between w-full h-full py-[30px] pl-[30px]" *ngIf="currentAdScreen === 'Fourth'">
                <p class="title text-white font-bold text-[2.7vw] w-[45%]">{{ pageTitles[3] }}</p>
                <div class="w-[75%] h-full items-center justify-center flex flex-col">
                    <div class="w-full flex flex-row justify-center items-center">
                        <img src="https://jotto-imgs.s3.us-west-2.amazonaws.com/ad_4.svg" alt="ad-4"/>
                        <div class="third-text flex flex-row justify-center ml-10">
                            <h2 class="fourthtext text-white !font-normal !text-[2vw] mt-14 max-w-80">
                                {{ pageCaptions[3] }}
                            </h2>
                        </div>
                    </div>
                </div>
                <!-- <div class="w-[20%] flex flex-row justify-start items-end absolute bottom-12 left-6">
                    <div class="flex flex-col h-full justify-end items-start">
                        <p class="text-white text-left font-semibold leading-none text-[2vw]">www.jotto.me</p>
                        <p class="text-white text-left font-normal leading-none text-[.8vw]">©2024 Jotto, Inc. All rights reserved.</p>
                    </div>
                </div> -->
            </div>

            <div class="w-[20%] flex flex-row justify-start items-end absolute bottom-12 left-6">
                <div class="flex flex-col h-full justify-end items-start">
                    <p class="text-white text-left font-semibold leading-none text-[2vw]">www.jotto.me</p>
                    <p class="text-white text-left font-normal width-full leading-none text-[.8vw] text-nowrap">©2024 Jotto, Inc. All rights reserved.</p>
                </div>
            </div>
        </div>
        <!--STANDARD VIEW WHERE THE PURPLE IS NOT THE MAJORITY OF THE SCREEN-->
        <div class="h-full fade-in" *ngIf="!isExpanded" [@expandCollapse]>
            <div class="flex flex-col items-start justify-between w-full h-full p-[30px]">
                <p *ngIf="loaded" class="text-white font-bold leading-[1.3] text-[2.7vw] w-[90%]">{{ notification?.cta }}</p>
                <div class="w-[90%] flex flex-row justify-start items-center" [@onOffOpacity] (click)="handleClick()">
                    <div class="flex flex-col justify-start items-start mr-[5%] !p-0">
                        <div class="flex flex-col justify-start items-center">
                            <img *ngIf="channel && notification.qr_code?.url" [src]="notification.qr_code?.url" [ngStyle]="{ width: window.innerWidth * 0.12 + 'px', height: window.innerWidth * 0.12
                            + 'px' }"/>
                            <ngx-qrcode-styling *ngIf="channel && !notification.qr_code?.url" [config]="qrcodeConfig"></ngx-qrcode-styling>
                            <a *ngIf="channel" [href]="linkType === 'PROMPT' ? notification?.alt_stv_url : channel.share_url" class="m-0 mt-4 text-white font-semibold py-2">
                                {{ linkType === 'PROMPT' ? notification.alt_stv_url : channel.share_url }}
                            </a>
                        </div>
                    </div>
                    <p class="text-white font-semibold !mb-[0%] leading-normal text-[1.7vw]">
                        Scan or click to
                        <br/>
                        share your thoughts.
                    </p>
                </div>
                <div class="w-full flex flex-row justify-start items-center !p-0" [@onOffOpacity]>
                    <img [src]="'/assets/images/Jotto-Empowering-White.png'" class="w-[30%] mr-[15%]"/>
                    <p class="text-white font-semibold !mb-[0%] max-w-[50%] leading-normal text-[1.2vw]">Learn how Jotto can help you connect with your community visit www.jotto.video</p>
                </div>
            </div>
        </div>
    </div>
    <!--HANDLES THE IMAGE ON THE TOP RIGHT IF IS EXPANDED THROUGH ABSOLUTE LAYOUT - OTHERWISE NORMAL STANDARD VIEW-->
    <img class="jotto-purple {{ !isExpanded ? 'collapse' : 'visible' }}" [src]="'/assets/images/Jotto-Empowering-Purple.png'" [@opacityInAndOut]="!isExpanded ? 'collapsed' : 'expanded'"/>
    <div class="w-full {{ isExpanded ? 'collapse' : 'visible' }}" [@opacityInAndOut]="isExpanded ? 'collapsed' : 'expanded'">
        <div class="flex flex-col justify-center items-start w-full h-full py-[10px] pl-0">
            <div class="flex flex-row justify-end items-center w-full mb-auto pr-[30px]">
                <img [src]="notification?.sponsor_image?.url" class="h-[10vh]"/>
            </div>
            <div class="w-full h-full">
                <portals-word-cloud (toggleAnimation)="toggle($event)" *ngIf="wordCount?.words?.[0]" [data]="wordCount"></portals-word-cloud>
            </div>
            <div class="flex flex-row justify-between items-end w-full mt-[2%] pl-[30px] pr-[30px]">
                <p class="m-0 text-right font-normal leading-normal text-[.8vw]">©2024 Jotto, Inc. All rights reserved.</p>
                <img [src]="channel?.landscape_image?.url" class="h-[10vh] mb-[30px]"/>
            </div>
        </div>
    </div>
</div>
<!--HANDLES THE MOBILE VIEW-->
<div *ngIf="deviceService.isMobile()" class="w-full h-screen">
    <div class="w-full h-screen flex flex-col">
        <!-- Expanded View -->
        <div class="flex flex-col flex-shrink-0 justify-start items-center w-full rounded-b-xl pt-[42px]" [ngStyle]="getBackgroundColorClass()"
             [@expandCollapseMobile]="isExpanded ? 'expanded' : 'collapsed'" [style.height]="isExpanded ? '100%' : 'fit-content'">
            <ng-container *ngIf="isExpanded">
                <!-- Ad Screens -->
                <ng-container [ngSwitch]="currentAdScreen">
                    <!-- First and Second Ad Screen -->
                    <div *ngSwitchCase="'First'" class="fade-in flex flex-col items-center h-5/6 w-full pt-12 mt-[4vh]">
                        <p class="text-white font-bold w-full leading-loose text-2xl text-center">
                            {{ pageTitles[1] }}
                        </p>
                        <div class="w-full items-center justify-center flex flex-col mt-[10vh]">
                            <div class="w-full flex flex-row justify-center">
                                <portals-image-auto-carousel></portals-image-auto-carousel>
                            </div>
                            <div class="text-center mt-[4vh]">
                                <h1 class="!text-full my-4 text-white">{{ pageCaptions[1] }}</h1>
                            </div>
                        </div>
                    </div>

                    <!-- Third Ad Screen -->
                    <div *ngSwitchCase="'Third'" class="fade-in flex flex-col items-center h-5/6 w-full pt-12 mt-[4vh]">
                        <p class="text-2xl text-white font-bold text-full w-full leading-loose text-center">{{ pageTitles[2] }}</p>
                        <div class="w-full items-center justify-center flex flex-col mt-[10vh]">
                            <img src="https://jotto-imgs.s3.us-west-2.amazonaws.com/third_1.png" alt="ad_3_1" class="w-6/12"/>
                            <div class="text-center mt-[4vh]">
                                <h1 class="!text-full my-4 p-2 text-white">{{ pageCaptions[2] }}</h1>
                            </div>
                        </div>
                    </div>

                    <!-- Fourth Ad Screen -->
                    <div *ngSwitchCase="'Fourth'" class="fade-in flex flex-col items-center h-5/6 w-full pt-12 mt-[4vh]">
                        <p class="text-2xl text-white font-bold text-full w-full leading-loose text-center">{{ pageTitles[3] }}</p>
                        <div class="w-full items-center justify-center flex flex-col mt-[10vh]">
                            <div class="w-full flex flex-col justify-center items-center">
                                <img src="https://jotto-imgs.s3.us-west-2.amazonaws.com/ad_4.svg" alt="ad-4"/>
                                <div class="text-center mt-[2vh] full flex flex-row justify-center">
                                    <h1 class="my-4 p-2 text-white w-7/12">{{ pageCaptions[3] }}</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <!-- Footer for expanded view -->
                <div class="w-full h-1/6 flex flex-row justify-between items-end absolute bottom-4 px-2">
                    <img [src]="'/assets/images/Jotto-Empowering-White.png'" class="w-[20%]"/>
                    <div>
                        <p class="text-white text-right !mb-[0%] leading-normal font-thin text-[1.5vh]">
                            Connect with your
                            <br/>
                            community visit
                            <br/>
                            <b>www.jotto.video</b>
                        </p>
                        <p class="m-0 text-white mt-auto font-normal leading-normal text-[8px]">©2024 Jotto, Inc. All rights reserved.</p>
                    </div>
                </div>
            </ng-container>
            <div *ngIf="!isExpanded" class="fade-in flex flex-col justify-start items-center w-full">
                <div class="w-full flex flex-row justify-between bg-white h-12 px-6 py-2 mb-6">
                    <img *ngIf="notification?.sponsor_image?.url || channel?.landscape_image?.url" [src]="notification?.sponsor_image?.url || channel?.landscape_image?.url" class="w-6/12"/>
                    <img *ngIf="notification?.sponsor_image?.url" [src]="channel?.landscape_image?.url" class="w-5/12"/>
                </div>
                <div class="w-full px-6 mb-6">
                    <p class="text-white text-left !mb-[0px] font-semibold leading-[1.3] text-[18px] w-full">{{ notification?.cta }}</p>
                </div>
                <button class="py-[1vh] px-[2vh] bg-portals-theme-accent-text rounded-full mb-1" (click)="navigateToUrl()">
                    <b class="mx-[1vh] font-semibold text-[14px]">Provide Feedback</b>
                </button>
                <div class="h-8 px-6 flex flex-col justify-center mb-1">
					<span class="text-white text-[8px]">
						By clicking
						<strong>Provide Feedback</strong>
						you agree to the Jotto
						<a href="https://jotto.me/policies/terms" class="underline" target="_blank">Terms</a>
						and
						<a href="https://jotto.me/policies/privacy" target="_blank" class="underline">Privacy Policy</a>
					</span>
                </div>
            </div>
        </div>

        <!-- Collapsed View -->

        <!-- Word Cloud Section -->
        <div class="w-full flex-grow">
            <div class="flex flex-col justify-center items-start w-full h-full px-[5vw]">
                <div class="w-full"></div>
                <div class="w-full h-3/4">
                    <portals-word-cloud (toggleAnimation)="toggle($event)" *ngIf="wordCount?.words?.[0]" [data]="wordCount"></portals-word-cloud>
                </div>
            </div>
        </div>

        <!-- Bottom Footer -->
        <!-- <div class="fixed bottom-0 left-0 right-0">
            <div class="w-full h-full flex flex-row justify-between items-center py-[12px] px-6 text-white" [ngStyle]="getBackgroundColorClass()">
                <img [src]="'/assets/images/Jotto-Empowering-White.png'" class="w-[30%] my-auto" />
                <div class="w-6/12">
                    <p class="text-right !mb-[0%] leading-tight text-[8px]">Learn how Jotto can help with you connect with your community, visit jotto.me</p>
                    <p class="text-right m-0 mt-auto font-light leading-normal text-[6px]">©2024 Jotto, Inc. All rights reserved.</p>
                </div>
            </div>
        </div> -->
        <div class="w-full flex-shrink-0">
            <div class="w-full flex flex-row justify-between items-center py-[12px] px-6 text-white" [ngStyle]="getBackgroundColorClass()">
                <img [src]="'/assets/images/Jotto-Empowering-White.png'" class="w-[30%] my-auto"/>
                <div class="w-7/12">
                    <p class="text-right mb-2 leading-tight text-[10px]">
                        Learn how Jotto can help you connect
                        <br/>
                        with your community visit www.jotto.me
                    </p>
                    <p class="text-right m-0 mt-auto font-light leading-normal text-[6px]">©2024 Jotto, Inc. All rights reserved.</p>
                </div>
            </div>
        </div>
    </div>

    <ng-template #dialogTemplate>
        <h1 mat-dialog-title>Check Modal</h1>
        <div mat-dialog-content>
            <div>
                <div style="display: flex; flex-direction: column">
                    <mat-slide-toggle [checked]="showAd$.value" (change)="showAd$.next($event.checked)">Show Ad</mat-slide-toggle>
                    <mat-slide-toggle [checked]="autoRefresh$.value" (change)="autoRefresh$.next($event.checked)">Auto Refresh</mat-slide-toggle>
                </div>
                <div>
                    <label for=""></label>
                </div>
            </div>
        </div>
        <div mat-dialog-actions>
            <button mat-button (click)="closeDialog()">Close</button>
        </div>
    </ng-template>
</div>
